(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	// Mobile browsers fire 'resize' whenever the address bar shows/hides while
	// scrolling or swiping. Rebuilding on those height-only changes reset the
	// gallery to the first image mid-swipe, so only rebuild when the width changes.
	var lastWidth = window.innerWidth;
	var resizeTimer;

	window.addEventListener('resize', function () {
		if (window.innerWidth === lastWidth) return;
		lastWidth = window.innerWidth;

		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			$('.product-section .js-media-list').each(function () {
				if (this.swiper) this.swiper.destroy();
			});
			$('.product-section .js-media-sublist').each(function () {
				if (this.swiper) this.swiper.destroy();
			});

			swiperInit();
		}, 200);
	});

	swiperInit();
})();
